import React from 'react';
import styled from '@emotion/styled';
import { graphql } from 'gatsby';
import { SEO, devices, Text, Spacing, Stack } from '../components/common';
import HeroSection from '../components/HeroSection';
import Accordion from '../components/Accordion';
import type { PrivacyPage, MetaData } from '../@types/types';

type Props = {
  data: {
    page: PrivacyPage;
    MetaData: MetaData;
  };
  location: Location;
};

const Privacy = ({ data, location }: Props) => {
  const {
    page: { MetaData, PageTopSection, DataProtectionItem },
  } = data;

  return (
    <>
      <SEO
        pathname={location.pathname}
        title={MetaData?.MetaTitle}
        description={MetaData?.MetaDescription}
        keywords={MetaData?.metaKeywords}
      />

      <HeroSection topSection={PageTopSection} />

      <AccordionSection>
        <AccordionContainer>
          {DataProtectionItem.map((item, index) => {
            return (
              <Accordion key={index} header={item.Header} text={item.Content} />
            );
          })}
        </AccordionContainer>
      </AccordionSection>

      <script
        id="CookieDeclaration"
        src="https://consent.cookiebot.com/1567fbb9-2872-482f-8763-bd1ee129bfd7/cd.js"
        type="text/javascript"
        async
      ></script>
    </>
  );
};

export default Privacy;

export const privacyQuery = graphql`
  query PrivacyPageQuery {
    page: strapiTietosuoja {
      ...strapiPrivacyFragment
    }
  }
`;

const AccordionSection = styled.div`
  background-color: ${(props) => props.theme.colors.lightBlue};
`;

const AccordionContainer = styled.div`
  width: 70ch;
  margin: auto;
  padding: ${(props) => props.theme.spacing.xxlarge} 0px;

  @media ${devices.laptop} {
    width: 90%;
  }
`;

const CookieItem = styled.li`
  list-style-type: none;
`;

const CookieType = styled(Text)`
  text-decoration: underline;
`;

const ChangeCookies = styled.button`
  ${(props) => props.theme.typography.body};
  border: none;
  background: ${(props) => props.theme.colors.darkBlue};
  color: ${(props) => props.theme.colors.white};
  padding: ${(props) => props.theme.spacing.small}
    ${(props) => props.theme.spacing.default};
  border-radius: 4px;

  &:hover {
    background-color: #36516a;
  }

  &:active {
    outline: none;
  }
`;
